import React from 'react';
import { VerticalTabsProps } from './VerticalTabs.types';
import { SIZE, SKIN } from './VerticalTabs.constants';

export type VerticalTabsContextValue<TabId extends string | number = number> =
  Pick<VerticalTabsProps<TabId>, 'size' | 'activeTabId' | 'onChange' | 'skin'>;

export default React.createContext<VerticalTabsContextValue<string | number>>({
  size: SIZE.MEDIUM,
  skin: SKIN.LIGHT,
});
